<template>
  <router-view />
</template>

<script>
export default {
  name: "statsMain",
};
</script>